
export const PCE_DETAIL_URL = '/demande/:requestId'
